import styled from '@emotion/styled/macro';

import FormTabOptions from '../../../../../../../styledComponents/UI/Form/FormTabOptions/FormTabOptions';

export const StyledFormTabOptions = styled(FormTabOptions)`
  width: 20rem;
`;
